// extracted by mini-css-extract-plugin
module.exports = {"page":"DemoContent_page__OwTT7","loading":"DemoContent_loading__KqRhV","loggedIn":"DemoContent_loggedIn__3Nf1Q"};